export enum UserTypes {
    TENANT_USER = 'tenantUser',
    TT_USER = 'ttUser',
    CUSTOMER = 'customer',
}
